/* eslint-disable max-len */
export default {
  MESSAGES: {
    CURRENT_DELIVERY_STATUS: 'Aktueller Lieferstatus',
    DATE: 'Datum',
    DELIVERY_HISTORY: 'Lieferverlauf',
    HOUR: 'Stunde',
    OBSERVATIONS: 'Beobachtungen',
    STATUS: 'Status'
  }
};
